import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@omilia/tooltip';

const ArchivedIcon = ({ name }) => (
  <Tooltip
    content={
      <React.Fragment>
        Archived
        <br />
        {name}
      </React.Fragment>
    }
    data-test="archived-icon-tooltip"
    placement="left"
  >
    <i className="icon-archived" data-test="archived-icon" />
  </Tooltip>
);
ArchivedIcon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default ArchivedIcon;
